import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
const benefits = ['Ahorrás dinero evitando errores costosos', 'Aprendés rápido sin conocimientos previos', 'Podés generar ingresos con tu propio emprendimiento', 'Método claro, práctico y probado'];
export function BenefitsSection() {
  return <section className="py-12 bg-darker relative border-y border-white/5" data-id="element-17">
      <div className="container mx-auto px-4" data-id="element-18">
        <div className="max-w-4xl mx-auto text-center" data-id="element-19">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-6" data-id="element-20">
            LO QUE VAS A <span className="text-gradient-primary" data-id="element-21">LOGRAR</span>
          </motion.h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 text-left" data-id="element-22">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-card p-5 rounded-2xl border border-white/5" data-id="element-23">
                <CheckCircle className="w-8 h-8 text-accent-cyan shrink-0 mt-1" data-id="element-24" />
                <p className="text-xl text-gray-200 font-medium" data-id="element-25">{benefit}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-26">
            <CTAButton text="QUIERO EMPEZAR AHORA" data-id="element-27" />
          </motion.div>
        </div>
      </div>
    </section>;
}